export default {
    data() {
        return {
            success: {
                name: false,
                vatNumber: false,
                email: false,
                primaryPhone: false,
                companyCountry: false,
                vatCountry: false,
                loyaltyName: false,
                loyaltyCountry: false,
                pointsLabel: false,
                description: false
            },
            error: {
                name: "",
                vatNumber: "",
                email: "",
                primaryPhone: "",
                companyCountry: "",
                vatCountry: "",
                loyaltyName: "",
                loyaltyCountry: "",
                pointsLabel: "",
                description: ""
            },
            errorMessages: {
                nameRequired: {
                    el: "Απαιτείται Όνομα Εταιρείας",
                    en: "Company Name is required",
                    it: "È richiesto il nome dell'azienda"
                },
                nameLength: {
                    el: "Το Όνομα πρέπει να έχει τουλάχιστον 5 χαρακτήρες",
                    en: "Name must be at least 5 characters long",
                    it: "Il nome deve essere lungo almeno 5 caratteri"
                },
                vatNumberRequired: {
                    el: "Απαιτείται Αριθμός ΦΠΑ",
                    en: "Vat Number is required",
                    it: "È richiesto il numero di partita IVA"
                },
                vatNumberLength: {
                    el: "Ο Αριθμός ΑΦΜ πρέπει να έχει από 9 εώς χαρακτήρες",
                    en: "Vat Number must be from 9 to 12characters long",
                    it: "Il numero di partita IVA deve avere una lunghezza compresa tra 9 e 12 caratteri."
                },
                emailRequired: {
                    el: "Απαιτείται E-mail",
                    en: "E-mail is required",
                    it: "È richiesta l'e-mail"
                },
                emailValid: {
                    el: "Το E-mail πρέπει να είναι έγκυρο",
                    en: "E-mail must be valid",
                    it: "L'e-mail deve essere valida"
                },
                primaryPhoneRequired: {
                    el: "Απαιτείται Κύριο Τηλέφωνο",
                    en: "Primary Phone is required",
                    it: "È richiesto il telefono principale"
                },
                primaryPhoneLength: {
                    el: "Το Κύριο Τηλέφωνο πρέπει να έχει 10 χαρακτήρες",
                    en: "Primary Phone must be 10 characters long",
                    it: "Il telefono principale deve essere lungo 10 caratteri"
                },
                companyCountryRequired: {
                    el: "Απαιτείται Χώρα Εταιρείας",
                    en: "Company country is required",
                    it: "È richiesto il paese dell'azienda"
                },
                vatCountryRequired: {
                    el: "Απαιτείται Χώρα ΦΠΑ",
                    en: "Vat Country is required",
                    it: "È richiesto il paese dell'IVA"
                },
                loyaltyNameRequired: {
                    el: "Απαιτείται Όνομα (Αγγλικά, Ελληνικά)",
                    en: "Name is required (English, Greek)",
                    it: "È richiesto il nome (Inglese, Greco)"
                },
                loyaltyCountryRequired: {
                    el: "Απαιτείται Χώρα",
                    en: "Country is required",
                    it: "È richiesto il paese"
                },
                pointsLabelRequired: {
                    el: "Απαιτείται Ετικέτα Πόντων",
                    en: "Points Label is required",
                    it: "È richiesta l'etichetta dei punti"
                },
                descriptionRequired: {
                    el: "Απαιτείται Περιγραφή (Αγγλικά, Ελληνικά)",
                    en: "Description is required (English, Greek)",
                    it: "È richiesta la descrizione (Inglese, Greco)"
                }
            }
        };
    },

    computed: {
        valid() {
            return (
                this.success.name &&
                this.success.vatNumber &&
                this.success.email &&
                this.success.primaryPhone &&
                this.success.companyCountry &&
                this.success.vatCountry &&
                this.success.loyaltyName &&
                this.success.loyaltyCountry &&
                this.success.pointsLabel &&
                this.success.description
            );
        }
    },

    methods: {
        validateName() {
            if (!this.companyDetails.company_details.name) {
                this.error.name = this.errorMessages.nameRequired[this.lang];
            } else if (this.companyDetails.company_details.name.length < 5) {
                this.error.name = this.errorMessages.nameLength[this.lang];
            } else {
                this.error.name = "";
            }
        },

        async validateVatNumber() {
            let isValid = false;
            this.error.vatNumber = "";
            if (!this.companyDetails.company_details.vat_number) {
                this.error.vatNumber = this.errorMessages.vatNumberRequired[
                    this.lang
                ];
                isValid = false;
            } else if (this.companyDetails.company_details.vat_number.length < 9 || this.companyDetails.company_details.vat_number.length > 12) {
                this.error.vatNumber = this.errorMessages.vatNumberLength[
                    this.lang
                ];
                isValid = false;
            } else if (this.companyDetails.company_details.vat_number?.length >= 9) {
                let res = await this.checkVatNumber({
                    afm:this.companyDetails.company_details.vat_number, 
                    country_id: this.companyDetails.company_details.country_id
                });
                if (res.data?.status === "success") {
                    this.error.vatNumber = "";
                    isValid = true;
                } else if (res.data?.error) {
                    this.error.vatNumber = res.data?.message || "";
                    isValid = false;
                }
            }
            return isValid;
        },

        validateEmail() {
            if (!this.companyDetails.company_details.email) {
                this.error.email = this.errorMessages.emailRequired[this.lang];
            } else if (
                !/.+@.+/.test(this.companyDetails.company_details.email)
            ) {
                this.error.email = this.errorMessages.emailValid[this.lang];
            } else {
                this.error.email = "";
            }
        },

        validatePrimaryPhone() {
            if (!this.companyDetails.company_details.primary_phone) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneRequired[
                    this.lang
                ];
            } else if (
                this.companyDetails.company_details.primary_phone.length !== 10
            ) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneLength[
                    this.lang
                ];
            } else {
                this.error.primaryPhone = "";
            }
        },

        validateCompanyCountry() {
            if (!this.companyDetails.company_details.country_id) {
                this.error.companyCountry = this.errorMessages.companyCountryRequired[
                    this.lang
                ];
            } else {
                this.error.companyCountry = "";
                if (this.companyDetails.company_details.vat_number) {
                    this.validateVatNumber()
                }
            }
        },

        validateVatCountry() {
            if (!this.companyDetails.company_details.vat_country_id) {
                this.error.vatCountry = this.errorMessages.vatCountryRequired[
                    this.lang
                ];
            } else {
                this.error.vatCountry = "";
            }
        },

        validateLoyaltyName() {
            if (
                !this.companyDetails.loyalty_details.name.en ||
                !this.companyDetails.loyalty_details.name.el
            ) {
                this.error.loyaltyName = this.errorMessages.loyaltyNameRequired[
                    this.lang
                ];
            } else {
                this.error.loyaltyName = "";
            }
        },

        validateLoyaltyCountry() {
            if (!this.companyDetails.loyalty_details.country_id) {
                this.error.loyaltyCountry = this.errorMessages.loyaltyCountryRequired[
                    this.lang
                ];
            } else {
                this.error.loyaltyCountry = "";
            }
        },

        validatePointsLabel() {
            if (!this.companyDetails.loyalty_details.points_label) {
                this.error.pointsLabel = this.errorMessages.pointsLabelRequired[
                    this.lang
                ];
            } else {
                this.error.pointsLabel = "";
            }
        },

        validateDescription() {
            if (
                !this.companyDetails.loyalty_details.description.en ||
                !this.companyDetails.loyalty_details.description.el
            ) {
                this.error.description = this.errorMessages.descriptionRequired[
                    this.lang
                ];
            } else {
                this.error.description = "";
            }
        }
    },

    watch: {
        ["companyDetails.company_details.name"](val) {
            if (val) {
                this.success.name = val.length >= 5;
            } else {
                this.success.name = false;
            }
        },

        ["companyDetails.company_details.vat_number"]: {
            immediate: true,
            async handler(val) {
                if (val?.length >= 9) {
                    this.success.vatNumber = await this.validateVatNumber();
                } else {
                    this.success.vatNumber = false;
                }
            }
        },

        ["companyDetails.company_details.email"](val) {
            this.success.email = /.+@.+/.test(val);
        },

        ["companyDetails.company_details.primary_phone"](val) {
            if (val) {
                this.success.primaryPhone = val.length === 10;
            } else {
                this.success.primaryPhone = false;
            }
        },

        ["companyDetails.company_details.country_id"](val) {
            if (val) {
                this.success.companyCountry = true;
            } else {
                this.success.companyCountry = false;
            }
        },

        ["companyDetails.company_details.vat_country_id"](val) {
            if (val) {
                this.success.vatCountry = true;
            } else {
                this.success.vatCountry = false;
            }
        },

        ["companyDetails.loyalty_details.name.en"](val) {
            if (val) {
                this.success.loyaltyName = true;
            } else {
                this.success.loyaltyName = false;
            }
        },

        ["companyDetails.loyalty_details.description.en"](val) {
            if (val) {
                this.success.description = true;
            } else {
                this.success.description = false;
            }
        },

        ["companyDetails.loyalty_details.country_id"](val) {
            if (val) {
                this.success.loyaltyCountry = true;
            } else {
                this.success.loyaltyCountry = false;
            }
        },

        ["companyDetails.loyalty_details.points_label"](val) {
            if (val) {
                this.success.pointsLabel = true;
            } else {
                this.success.pointsLabel = false;
            }
        }
    }
};
